"use strict";
/*
 * Created on 16.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var WindowProductDetails_1 = require("../model/WindowProductDetails");
/**
 * @author MSu
 */


var WindowProductDetailsConverterImpl =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowProductDetailsConverterImpl, _DataObjectConverter_);

  function WindowProductDetailsConverterImpl() {
    _classCallCheck(this, WindowProductDetailsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowProductDetailsConverterImpl).apply(this, arguments));
  }

  _createClass(WindowProductDetailsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowProductDetails_1.WindowProductDetails(conversions.toClassReferenceId(source.windowId), conversions.toClassReferenceId(source.windowItemId), conversions.toClassReferenceId(source.productId));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowId: conversions.toDocumentReferenceId(source.windowId),
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        productId: conversions.toDocumentReferenceId(source.productId)
      });
      return result;
    }
  }]);

  return WindowProductDetailsConverterImpl;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowProductDetailsConverterImpl = WindowProductDetailsConverterImpl;